import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ sx, to }) {
  return (
    <ButtonBase disableRipple component={Link} to={to || APP_DEFAULT_PATH} sx={sx}>
      <Typography variant="h6" color="primary" sx={{ fontWeight: 700, fontSize: '1.75rem', ml: 5, mt: 2 }}>
        Kairos
      </Typography>
    </ButtonBase>
  );
}

LogoSection.propTypes = {
  sx: PropTypes.any,
  to: PropTypes.any
};
